import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { apiUrl } from "@/lib/media";
import { useLang, EVENT_TYPES_EN } from "@/lib/i18n";

const EMPTY = { name: "", email: "", phone: "", event_type: EVENT_TYPES_EN[0], event_date: "", budget: "", location: "", message: "", website: "" };

const Field = ({ id, label, full, children }) => (
  <div className={full ? "full" : undefined}><label htmlFor={id}>{label}</label>{children}</div>
);

export const Inquiry = () => {
  const { t } = useLang();
  const f = t.form;
  const [form, setForm] = useState(EMPTY);
  const [state, setState] = useState("idle");
  const [error, setError] = useState("");
  const started = useRef(Date.now());
  useEffect(() => { started.current = Date.now(); }, []);
  const bind = (k) => ({ value: form[k], onChange: (e) => setForm({ ...form, [k]: e.target.value }), "data-testid": `inquiry-${k.replace("_", "-")}-input` });

  const submit = async (e) => {
    e.preventDefault();
    setState("sending"); setError("");
    try {
      await axios.post(apiUrl("/inquiries"), { ...form, elapsed_ms: Date.now() - started.current });
      setState("done");
    } catch (err) {
      setState("idle");
      setError(err?.response?.status === 429 ? "tooMany" : "error");
    }
  };

  return (
    <section className="alt" id="inquire" data-testid="inquiry-section">
      <div className="wrap">
        <h2>{f.h}</h2>
        <p className="lede">{f.lede}</p>
        {state === "done" ? (
          <div className="ok" role="status" data-testid="inquiry-success"><h3>{f.thanks}</h3><p>{f.thanksP}</p></div>
        ) : (
          <form onSubmit={submit} data-testid="inquiry-form">
            <Field id="n" label={f.name}><input id="n" required autoComplete="name" maxLength={120} {...bind("name")} /></Field>
            <Field id="e" label={f.email}><input id="e" type="email" required autoComplete="email" {...bind("email")} /></Field>
            <Field id="p" label={f.phone}><input id="p" type="tel" autoComplete="tel" maxLength={40} {...bind("phone")} /></Field>
            <Field id="t" label={f.type}>
              <select id="t" {...bind("event_type")}>{EVENT_TYPES_EN.map((v, i) => <option key={v} value={v}>{f.types[i]}</option>)}</select>
            </Field>
            <Field id="d" label={f.date}><input id="d" type="date" {...bind("event_date")} /></Field>
            <Field id="b" label={f.budget}><input id="b" maxLength={120} {...bind("budget")} /></Field>
            <Field id="l" label={f.location} full><input id="l" maxLength={200} {...bind("location")} /></Field>
            <Field id="m" label={f.message} full><textarea id="m" maxLength={4000} {...bind("message")} /></Field>
            <div className="hp" aria-hidden="true">
              <label htmlFor="w">Website</label><input id="w" tabIndex={-1} autoComplete="off" {...bind("website")} />
            </div>
            {error && <p className="full form-err" role="alert" data-testid="inquiry-error">{f[error]}</p>}
            <div className="full"><button className="btn" type="submit" disabled={state === "sending"} data-testid="inquiry-submit-btn">{state === "sending" ? f.sending : f.send}</button></div>
          </form>
        )}
      </div>
    </section>
  );
};
